export const menuItems = [
    // { label: 'Run', action: 'run' },
    // { label: 'Edit', action: 'edit' },
    // { label: 'Permissions', action: 'permissions' },
    { label: 'Delete', action: 'delete' },
    // { label: 'Copy Collections', action: 'copy' },
];
  